import { wormColors } from "core/src/core/constants.js";
import { POWERUPS } from "../../../shared/powerups";

// What happened in a round, as marks for the replay's scrubber: every crash (in
// that player's colour; the viewer's own raised), every power-up grabbed (in the
// colour of who it affects), and how much of the round is the countdown. All of it
// is read from the round's own event logs, which every replay already carries.

export interface TimelineMark {
  time: number;          // game time
  kind: "crash" | "pickup";
  color: string;
  label: string;         // "CometKid crashed into GapHunter's trail"
  you: boolean;          // the viewer's own crash
}
export interface Timeline { duration: number; countdown: number; marks: TimelineMark[] }

const AFFECTS_COLOR: Record<string, string> = { self: "#46d97e", others: "#ff5c74", all: "#5aa0fa" };
const POWERUP_NAME: Record<string, string> = Object.fromEntries(POWERUPS.map((p) => [p.key, p.name]));

export function buildTimeline(gameState: any, players: any[], youIds: string[] = []): Timeline {
  const duration = gameState.gameTime || 0;
  const nameOf = (id: any) => (players.find((p) => p.id === id) || {}).name || "A player";
  const colorOf = (id: any) => (wormColors as any)[(players.find((p) => p.id === id) || {}).colorId] || "#8995b3";
  const ownerOfTrack = (trackId: any) => { const segs = (gameState.wormPathSegments || {})[trackId]; return segs && segs[0] ? segs[0].playerId : null; };
  const marks: TimelineMark[] = [];

  for (const e of gameState.gameEvents || []) {
    if (e.type !== "worm_died" || !(e.time <= duration + 1e-6)) continue;
    const how = e.cause === "wall" ? " hit the wall"
      : e.cause === "trail" ? (e.killerPlayerId === e.playerId ? " crashed into their own trail" : ` crashed into ${nameOf(e.killerPlayerId)}'s trail`)
      : " crashed";
    marks.push({ time: e.time, kind: "crash", color: colorOf(e.playerId), label: nameOf(e.playerId) + how, you: youIds.includes(e.playerId) });
  }

  const spawned: Record<string, any> = {};
  for (const e of gameState.powerUpEvents || []) {
    if (e.type === "spawn" && e.powerUp) spawned[e.powerUp.id] = e.powerUp;
    if (e.type !== "despawn" || e.grabbedBy == null || !(e.time <= duration + 1e-6)) continue;
    const pu = spawned[e.id];
    if (!pu) continue;
    marks.push({ time: e.time, kind: "pickup", color: AFFECTS_COLOR[pu.affects] || "#8995b3", label: `${nameOf(ownerOfTrack(e.grabbedBy))} grabbed ${POWERUP_NAME[pu.name] || pu.name}`, you: false });
  }

  marks.sort((a, b) => a.time - b.time);
  return { duration, countdown: Math.min(duration, gameState.startPhaseTime || 0), marks };
}

export function formatClock(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  return Math.floor(s / 60) + ":" + (s % 60 < 10 ? "0" : "") + (s % 60);
}
